

export const niceUnitDisplayer = ({dist, unit}) => {
  
  switch(unit){
    case "deg":
      return `${parseInt(dist)}${unit}`
    case "m":
      if (Math.abs(dist) > 1){
        return `${parseInt(dist)}m`
      }else if (Math.abs(dist) > 0.01) {
        return `${parseInt(dist*100)}cm`
      }else if (Math.abs(dist) > 0.001){
        return `${parseInt(dist*1000)}mm`      
      }else{
        return `${(dist*1000).toFixed(3)}mm`            
      }
    case "px":
      return `${parseInt(dist)}${unit}`
    default:
      return `${dist.toFixed(3)}${unit}`
  }
}